import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppLayout from "@/components/layout/AppLayout";
import { Toaster } from "sonner";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Clients from "@/pages/Clients";
import Employees from "@/pages/Employees";
import Tasks from "@/pages/Tasks";
import Compliance from "@/pages/Compliance";
import Documents from "@/pages/Documents";
import CalendarPage from "@/pages/CalendarPage";
import Payments from "@/pages/Payments";
import Reports from "@/pages/Reports";
import Notifications from "@/pages/Notifications";
import AuditLogs from "@/pages/AuditLogs";
import Settings from "@/pages/Settings";
import Profile from "@/pages/Profile";
import PlatformFirms from "@/pages/PlatformFirms";
import PlatformAnalytics from "@/pages/PlatformAnalytics";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <AuthProvider>
                    <Toaster position="top-right" richColors closeButton />
                    <Routes>
                        <Route path="/login" element={<Login />} />
                        <Route path="/register" element={<Register />} />
                        <Route
                            element={
                                <ProtectedRoute>
                                    <AppLayout />
                                </ProtectedRoute>
                            }
                        >
                            <Route path="/" element={<Navigate to="/dashboard" replace />} />
                            <Route
                                path="/platform"
                                element={
                                    <ProtectedRoute roles={["super_admin"]}>
                                        <PlatformFirms />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/platform/analytics"
                                element={
                                    <ProtectedRoute roles={["super_admin"]}>
                                        <PlatformAnalytics />
                                    </ProtectedRoute>
                                }
                            />
                            <Route path="/dashboard" element={<Dashboard />} />
                            <Route path="/clients" element={<Clients />} />
                            <Route
                                path="/employees"
                                element={
                                    <ProtectedRoute roles={["admin", "super_admin"]}>
                                        <Employees />
                                    </ProtectedRoute>
                                }
                            />
                            <Route path="/tasks" element={<Tasks />} />
                            <Route path="/compliance" element={<Compliance />} />
                            <Route path="/documents" element={<Documents />} />
                            <Route path="/calendar" element={<CalendarPage />} />
                            <Route
                                path="/payments"
                                element={
                                    <ProtectedRoute roles={["admin", "super_admin"]}>
                                        <Payments />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/reports"
                                element={
                                    <ProtectedRoute roles={["admin", "super_admin"]}>
                                        <Reports />
                                    </ProtectedRoute>
                                }
                            />
                            <Route path="/notifications" element={<Notifications />} />
                            <Route path="/profile" element={<Profile />} />
                            <Route
                                path="/audit"
                                element={
                                    <ProtectedRoute roles={["admin", "super_admin"]}>
                                        <AuditLogs />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/settings"
                                element={
                                    <ProtectedRoute roles={["admin", "super_admin"]}>
                                        <Settings />
                                    </ProtectedRoute>
                                }
                            />
                        </Route>
                        <Route path="*" element={<Navigate to="/dashboard" replace />} />
                    </Routes>
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
